import { heroCover } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src={heroCover}
        alt="吃瓜投稿匿名爆料曝光大主视觉"
        title="吃瓜投稿匿名爆料曝光"
        className="absolute inset-0 w-full h-full object-top object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pt-24 pb-14 md:py-20 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur text-background-50 text-xs px-4 py-1.5 border border-white/25 mb-6 md:mb-8">
          <i className="ri-shield-check-line text-secondary-300 text-sm"></i>
          匿名通道在线 · 每条线索经人工复核
        </span>

        <h1 className="font-heading text-background-50 text-3xl md:text-5xl lg:text-[3.4rem] font-black leading-tight tracking-tight">
          手里有瓜，<br className="md:hidden" />不敢实名说出口？
        </h1>
        <p className="mx-auto mt-5 md:mt-6 max-w-2xl text-background-100 text-base md:text-lg leading-relaxed">
          吃瓜投稿的匿名通道接收爆料、曝光与内幕线索。隐私我们兜底，瓜帮你见光。
          想合作、想递一手材料，按下面的匿名规则提交就行，少一点后顾之忧。
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="#submit"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-400 text-background-50 text-base px-7 py-3.5 font-medium transition-colors w-full sm:w-auto justify-center whitespace-nowrap"
          >
            <i className="ri-upload-cloud-2-line text-lg"></i>
            匿名投递线索
          </a>
          <a
            href="#feed"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur hover:bg-white/20 text-background-50 text-base px-7 py-3.5 font-medium border border-white/30 transition-colors w-full sm:w-auto justify-center whitespace-nowrap"
          >
            <i className="ri-eye-line text-lg"></i>
            先看看今日瓜榜
          </a>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 max-w-lg mx-auto gap-2 text-background-50/90">
          {[
            { n: "2.4w+", t: "已接收爆料" },
            { n: "98%", t: "信息脱敏处理" },
            { n: "7×24h", t: "线索复核在线" },
          ].map((s) => (
            <div key={s.t} className="rounded-lg bg-white/10 backdrop-blur px-2 py-3 border border-white/15">
              <div className="font-heading text-lg md:text-xl font-bold">{s.n}</div>
              <div className="text-[11px] md:text-xs text-background-100/90 mt-1">{s.t}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}